{
  "name": "site-gold",
  "version": "1.28.3",
  "private": true,
  "type": "module",
  "scripts": {
    "build": "node scripts/zip-extension.mjs && esbuild client/app.ts --bundle --format=esm --minify --sourcemap --target=es2022 --outfile=public/app.js",
    "deploy": "npm run build && wrangler deploy",
    "typecheck": "tsc --noEmit && tsc --noEmit -p client"
  },
  "dependencies": {
    "@anthropic-ai/sdk": "^0.136.0",
    "@supabase/ssr": "^0.12.7",
    "@supabase/supabase-js": "^2.118.0",
    "drizzle-orm": "^0.45.4",
    "jose": "^6.2.13",
    "lightweight-charts": "^5.2.1",
    "postal-mime": "^2.7.6",
    "postgres": "^3.4.7",
    "unpdf": "^1.9.1"
  },
  "devDependencies": {
    "@cloudflare/workers-types": "^5.20260926.1",
    "drizzle-kit": "^0.31.11",
    "esbuild": "^0.28.2",
    "typescript": "^7.0.2",
    "wrangler": "^4.141.0"
  }
}
